import { useEffect, useState } from "react";

/**
 * Karşılaştırma listesi — ziyaretçinin tarayıcısında tutulur, en fazla 4 ürün.
 * Kartlar, ürün sayfası, alttaki çubuk ve /karsilastir sayfası aynı listeyi okur.
 */
const ANAHTAR = "akkuzey_karsilastir";
const OLAY = "akkuzey-karsilastir";
export const KARSILASTIRMA_SINIRI = 4;

const oku = () => {
  try {
    const v = JSON.parse(localStorage.getItem(ANAHTAR) || "[]");
    return Array.isArray(v) ? v.slice(0, KARSILASTIRMA_SINIRI) : [];
  } catch {
    return [];
  }
};

const yaz = (liste) => {
  try {
    localStorage.setItem(ANAHTAR, JSON.stringify(liste));
  } catch {
    /* depolama kapalı: liste bu sayfada tutulmaz */
  }
  window.dispatchEvent(new Event(OLAY));
};

export function useKarsilastirma() {
  const [idler, setIdler] = useState(oku);

  useEffect(() => {
    const yenile = () => setIdler(oku());
    window.addEventListener(OLAY, yenile);
    window.addEventListener("storage", yenile);
    return () => {
      window.removeEventListener(OLAY, yenile);
      window.removeEventListener("storage", yenile);
    };
  }, []);

  return {
    idler,
    icinde: (id) => idler.includes(id),
    dolu: idler.length >= KARSILASTIRMA_SINIRI,
    /** Ekler ya da çıkarır; liste doluysa false döner */
    degistir: (id) => {
      const mevcut = oku();
      if (mevcut.includes(id)) {
        yaz(mevcut.filter((x) => x !== id));
        return true;
      }
      if (mevcut.length >= KARSILASTIRMA_SINIRI) return false;
      yaz([...mevcut, id]);
      return true;
    },
    cikar: (id) => yaz(oku().filter((x) => x !== id)),
    temizle: () => yaz([]),
  };
}
